import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchLinks, publishLinks } from '../services/api'
import type { Link } from '../types'

export function useLinks() {
  return useQuery({
    queryKey: ['admin-links'],
    queryFn: fetchLinks,
    staleTime: 0,
    refetchOnWindowFocus: false,
  })
}

export function usePublishLinks() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ links, etag }: { links: Link[]; etag: string }) => publishLinks(links, etag),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-links'] })
    },
  })
}
